
		letterAdjust.scale = 0.8;
		// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
		var font = {
			".": "M672-98v-312H360v312H672z",
			"'": "M360,1638h311l0-648H360L360,1638z",
			"-": "M1008,770V459H360v311H1008z",
			"0": "M0,272.8l0,30.4C0,496.8,48,576,138.4,576c88.8,0,138.4-79.2,138.4-272.8l0-30.4 C276.8,79.2,227.2,0,138.4,0C48,0,0,79.2,0,272.8z M180,273.6v28.8c0,158.4-19.2,184-41.6,184c-23.2,0-42.4-25.6-42.4-184l0-28.8 c0-158.4,19.2-184,42.4-184C160.8,89.6,180,115.2,180,273.6z",
			"1": "M58.4,462.8L0,444.4l0,98.4L86.4,570l69.6,0l0-564L58.4,6L58.4,462.8z",
			"2": "M0,86.4l101.6,214.4c32,68,40.8,96.8,40.8,123.2c0,28-16.8,53.6-53.6,53.6 c-29.6,0-55.2-12.8-77.6-27.2l0,94.4c26.4,13.6,57.6,27.2,100,27.2c76,0,126.4-48,126.4-131.2v-4c0-44-10.4-86.4-43.2-152.8L104,100 l131.2,0l0-96L0,4L0,86.4z",
			"3": "M0,19.2L0,112c23.2-9.6,40.8-15.2,70.4-15.2c39.2,0,69.6,28.8,69.6,80v6.4 c0,58.4-38.4,82.4-97.6,86.4l0,64l91.2,143.2l-126.4,0l0,95.2l225.6,0l0-87.2l-94.4-146.4c56.8-19.2,97.6-59.2,97.6-148v-8.8 C236,71.2,171.2,4,83.2,4C48.8,4,23.2,9.6,0,19.2z",
			"4": "M152,110.4l-152,0l0,74.4l147.2,384h96l0-374.4h45.6l0-84l-45.6,0l0-103.2l-91.2,0L152,110.4z  M152,194.4l0,204.8L79.2,194.4L152,194.4z",
			"5": "M4,19.2l0,95.2c18.4-9.6,42.4-16.8,64-16.8c45.6,0,71.2,37.6,71.2,97.6v5.6 c0,59.2-21.6,80-53.6,80c-14.4,0-24.8-2.4-38.4-8L0,304l15.2,268l199.2,0l0-92.8l-127.2,0L80,365.6c10.4,2.4,21.6,4,37.6,4 c59.2,0,117.6-43.2,117.6-168v-7.2C235.2,72.8,171.2,4,78.4,4C50.4,4,22.4,11.2,4,19.2z",
			"6": "M55.2,29.6C18.4,66.4,0,140.8,0,261.6l0,20.8C0,513.6,66.4,576,157.6,576 c29.6,0,48.8-5.6,67.2-12.8l0-92C209.6,480,188,488,168,488c-44,0-74.4-30.4-75.2-141.6c20,16.8,36.8,24,63.2,24 c51.2,0,104.8-39.2,104.8-163.2v-16.8C260.8,75.2,206.4,0,131.2,0C100.8,0,76,8.8,55.2,29.6z M169.6,186.4V204 c0,64-18.4,85.6-41.6,85.6c-16,0-25.6-6.4-34.4-14.4l0-68.8c0-86.4,15.2-119.2,38.4-119.2C156,87.2,169.6,117.6,169.6,186.4z",
			"7": "M140,469.6l-140,0L0,568l233.6,0l0-68.8L128.8,8L33.6,8L140,469.6z",
			"8": "M0,163.2l0,5.6C0,242.4,34.4,287.2,64.8,308C28.8,331.2,8,372,8,427.2l0,4.8 c0,89.6,56.8,144,124.8,144c68,0,124.8-54.4,124.8-144v-4.8c0-55.2-20.8-96-56.8-119.2c30.4-20.8,64.8-65.6,64.8-139.2v-5.6 C265.6,60.8,209.6,0,132.8,0C56,0,0,60.8,0,163.2z M172,168l0,5.6c0,64.8-16.8,88.8-39.2,88.8c-22.4,0-39.2-24-39.2-88.8V168 c0-68,16.8-90.4,39.2-90.4C155.2,77.6,172,100,172,168z M168,417.6v4.8c0,58.4-16,76.8-35.2,76.8s-35.2-18.4-35.2-76.8v-4.8 c0-54.4,13.6-80,35.2-80C154.4,337.6,168,363.2,168,417.6z",
			"9": "M168,222.4c-20-16.8-38.4-23.2-63.2-23.2C52,199.2,0,239.2,0,368l0,12.8 C0,502.4,54.4,576,129.6,576c30.4,0,55.2-8.8,76-29.6c36.8-36.8,55.2-111.2,55.2-232v-20.8C260.8,62.4,194.4,0,103.2,0 C73.6,0,50.4,6.4,28,15.2l0,92C48,96.8,71.2,88,92.8,88C135.2,88,165.6,118.4,168,222.4z M167.2,294.4l0,75.2 c0,86.4-15.2,119.2-38.4,119.2c-24,0-37.6-29.6-37.6-104v-13.6c0-68.8,16-91.2,41.6-91.2C148,280,158.4,286.4,167.2,294.4z",
			"A": "M289 -410l311 2048h465l311 -2048h-315l-68 443h-321l-68 -443h-315zM721 346h225l-112 739z",
			"B": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -14t68.5 -29.5t66.5 -49.5t56.5 -75t47 -102t29.5 -136t12.5 -176q0 -78 -24.5 -152t-59.5 -123t-68.5 -87t-58.5 -54l-25 -19q10 -6 25.5 -18t56.5 -54t72 -89t56.5 -121t25.5 -152q0 -96 -12.5 -176t-29.5 -136 t-47 -102.5t-56.5 -75t-66.5 -49t-68.5 -29.5t-72.5 -14.5t-66.5 -6.5t-61.5 -1h-480zM674 -98h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557zM674 770h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557z",
			"C": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089q0 -70 48.5 -118t118 -48t118.5 48t49 118v249h314v-249q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
			"D": "M360 -410v2048h480q199 0 340 -140t141 -339v-1089q0 -199 -141.5 -339.5t-339.5 -140.5h-480zM674 -96h166q70 0 119 48t49 118v1089q0 70 -49.5 119t-118.5 49h-166v-1423z",
			"E": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-557h491v-312h-803z",
			"F": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-869h-312z",
			"G": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-119 -48t-49.5 -118v-1089q0 -70 49.5 -118t119 -48t118.5 48t49 118v233h-168v311h482v-1024h-158l-70 187q-4 -8 -11 -20.5t-34.5 -45.5t-63.5 -56.5t-96.5 -44 t-132.5 -20.5q-190 0 -292.5 135.5t-102.5 344.5z",
			"H": "M360 -410v2048h314v-868h334v868h313v-2048h-313v869h-334v-869h-314z",
			"I": "M360 -410v2048h312v-2048h-312z",
			"J": "M293 -98h168q70 0 119 49t49 119v1568h311v-1568q0 -199 -140.5 -339.5t-338.5 -140.5h-168v312z",
			"K": "M360 -410v2048h312v-649l336 649h313l-365 -704l365 -1344h-313l-256 947l-80 -152v-795h-312z",
			"L": "M362 -410v2048h312v-1736h491v-312h-803z",
			"M": "M360 -410v2048h420l221 -1212l220 1212h419v-2048h-313v1414l-254 -1414h-145l-256 1414v-1414h-312z",
			"N": "M360 -410v2048h314l334 -1060v1060h313v-2048h-313l-334 1061v-1061h-314z",
			"O": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-1089q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5zM657 70q0 -70 48.5 -118t118 -48t118.5 48t49 118v1089q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089z",
			"P": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181t-12.5 -180t-29.5 -141.5t-47 -105.5t-56.5 -75.5t-66.5 -50t-68.5 -31t-72.5 -16.5t-66.5 -6h-61.5h-168v-834h-312zM672 735h168q168 0 168 296 t-168 296h-168v-592z",
			"Q": "M344 68v1089q0 199 141.5 340t340 141t340 -141t141.5 -340v-1089q-1 -113 -50 -211q66 -53 148 -54v-311q-209 0 -350 152q-106 -57 -230 -58q-199 0 -340 141.5t-141 340.5zM657 68q0 -70 49.5 -119t119 -49t118.5 49t49 119v1089q0 70 -49 119t-118.5 49t-119 -49 t-49.5 -119v-1089z",
			"R": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181q0 -440 -221 -559l221 -881h-322l-211 834h-116v-834h-312zM674 735h166q168 0 168 295t-168 295h-166v-590z",
			"S": "M344 70v110h313v-110q0 -70 48.5 -118t118 -48t118.5 48t49 118q0 82 -27.5 153.5t-72.5 124.5t-103.5 108.5t-120 103.5t-118.5 110.5t-103.5 128t-74 159t-27.5 201.5q0 199 140.5 339t339 140t340 -140t141.5 -339v-110h-314v110q0 70 -49 118t-118.5 48t-118 -48 t-48.5 -118q0 -74 21.5 -136t59.5 -109.5t86 -91.5t102.5 -86t107.5 -87t102.5 -101t86.5 -123t59.5 -157t22.5 -198q0 -199 -140.5 -339.5t-340 -140.5t-340 140.5t-140.5 339.5z",
			"T": "M330 1325v313h960v-313h-323v-1735h-314v1735h-323z",
			"U": "M356 70v1568h312v-1568q0 -70 49 -118t118.5 -48t119 48t49.5 118v1568h313v-1568q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
			"V": "M315 1638h314l166 -1099l168 1099h313l-313 -2048h-334z",
			"W": "M315 1638h314l166 -1179l168 1179h241l168 -1179l168 1179h311l-311 -2048h-336l-121 1024l-120 -1024h-334z",
			"X": "M338 -410l324 1024l-324 1024h313l166 -530l168 530h313l-323 -1024l323 -1024h-313l-168 531l-166 -531h-313z",
			"Y": "M297 1638h326l186 -606l186 606h326l-356 -1163v-885h-312v885z",
			"Z": "M358 -98l648 1423h-648v313h961v-313l-649 -1423h649v-312h-961v312z"
		};
		var font_size = 21,
			panel_Hor_Adjustment = -1,
			font_Top_Adjustment = -6,
			tracking = 0,
			small_Caps_Adjustment = {
				vertical: 0,
				horizontal: 0,
				scale_width: 0,
				scale_height: 0,
			},
			colors = {
				characters: {
					home: [
						"#FFFFFF",
					],
					away: [
						"#231F20", // black
					]
				},
				numbers: {
					home: [
						'#ED1B34', // red
						"#FFFFFF",
					],
					away: [
						'#ED1B34', // red
						"#231F20", // black
					]
				}
			},
			outlines = {
				characters: {
					width: 4
				},
				numbers: {
					width: 3
				}
			},
			special_Character_Adjustments = {
				period: {
					vertical: 3, // this moves it up from the bottom
					horizontal: -2.5,
					scale_width: 15.5,
					scale_height: 15.5,
				},
				hyphen: {
					vertical: 0,
					horizontal: -5.5,
					scale_width: 0,
					scale_height: -12,
				},
				apostrophe: {
					vertical: -5.75,
					horizontal: -2.5,
					scale_width: 0,
					scale_height: 0,
				}
			},
			number_Adjustments = {
				top: 3,
				left: -1.5,
				width: 210,
				height: 160,
				middle_Space: 5,
			};